import "./TopbarNotifications.scss"

import { BannerNotification } from "@skylead/component-library"
import classNames from "classnames"
import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"

import { useConfig, useGlobalTranslation } from "../../../utils/hook"
import { isInFreeTrial } from "../../../utils/payment-utils"

const TopbarNotifications = ({
  sidebar = false,
  addMarginBottom = false,
  setShowBanner = () => {},
}) => {
  const { tt } = useGlobalTranslation()
  const config = useConfig()

  const { accountID: accountId } = useParams()
  const isAccountSelected = accountId

  const { accountID, allSubscriptions, teamAccounts } = useSelector(state => ({
    accountID: state.account.activeAccountID,
    allSubscriptions: state.payment.allSubscriptions,
    teamAccounts: state.teamManagement.teamAccounts.items,
  }))

  const bannerContainerClass = classNames("banner-container", {
    "seat-notification-wrapper": sidebar,
    "add-margin-bottom": addMarginBottom,
  })

  const whitelabelId = Number(config.REACT_APP_PRODUCT_ID)
  const banner = useMemo(() => {
    let message = ""
    let type = ""
    const accountGlobalStatus = teamAccounts.find(account => +account.id === +accountID)
    const accountGlobalStatusId = accountGlobalStatus
      ? accountGlobalStatus.accountGlobalStatusId
      : ""
    if (+accountGlobalStatusId === 3) {
      message = tt("top-bar-notifications.status.id.3.msg")
      type = "pin"
    } else if (+accountGlobalStatusId === 12) {
      message = tt("top-bar-notifications.status.id.12.msg")
    } else if (+accountGlobalStatusId === 13) {
      message = tt("top-bar-notifications.status.id.13.msg")
      type = "pin"
    } else if (
      /** If emailOauths has at least one with active then it's okay */
      !accountGlobalStatus?.emailOauths.find(auth => auth.status === "ACTIVE") &&
      accountGlobalStatus?.email === null
    ) {
      message = ""
      if (whitelabelId && isAccountSelected) {
        message = tt("top-bar-notifications.status-confirmation.msg")
        type = "confirmation"
      }
    }
    return { message, type }
  }, [teamAccounts, accountID])

  const showBanners = useMemo(() => {
    const showBanner = !!banner?.message || isInFreeTrial(allSubscriptions)
    setShowBanner(showBanner)

    return showBanner
  }, [banner, allSubscriptions])

  if (!showBanners || !banner?.message) {
    return null
  }

  return (
    <div className={bannerContainerClass}>
      {showBanners && (
        <div className="d-flex w-100">
          {!!banner.message && <BannerNotification type={banner.type} label={banner.message} />}
        </div>
      )}
    </div>
  )
}

// TopbarNotifications.propTypes = {
//   sidebar: PropTypes.bool,
//   addMarginBottom: PropTypes.bool,
//   setShowBanner: PropTypes.func,
// }

export default TopbarNotifications
